// extracted by mini-css-extract-plugin
module.exports = {"root":"ColorPicker_root__mb6aU","colorPoint":"ColorPicker_colorPoint__IRkPj"};